import React from 'react';
import ComboSimple from '../../../../../shared/components/Combos/Simple';


export const ComboSociedades = (props) =>{
  
  return (
    <ComboSimple {...props} id="selectEstadosPartes"/>
  )
}
export default ComboSociedades